import React from 'react'
import { useIntl } from 'react-intl'

import LineUsersAltIcon from 'LuxKit/Icons/line/LineUsersAltIcon'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import { useTripCollaborators } from 'tripPlanner/hooks/api/collaborator'
import type { BasicTrip } from 'tripPlanner/types/common'

interface Props {
  trip: BasicTrip
}

export default function MyTripsTileShareContent({ trip }: Props) {
  const intl = useIntl()
  const { data } = useTripCollaborators({
    tripId: trip.id,
  })

  const owner = data?.collaborators.find((i) => i.role === 'OWNER')

  // User hasn't shared
  if (!data?.collaborators || data.collaborators.length < 2) {
    return null
  }

  return (
    <>
      {trip.role === 'OWNER' && (
        <CaptionTextBlock
          variant="large"
          startIcon={<LineUsersAltIcon size="XS" />}
        >
          {intl.formatMessage({
            id: 'MnIaPvg-Hc41bgNePpAI',
            defaultMessage: 'Shared by you',
            description: 'Share status when current user shared the trip in the trip planner',
          })}
        </CaptionTextBlock>
      )}
      {trip.role !== 'OWNER' && owner && (
        <CaptionTextBlock
          variant="large"
          startIcon={<LineUsersAltIcon size="XS" />}
        >
          {owner?.givenName
            ? intl.formatMessage({ id: 'lV2ktWsmKY_jwCJwkXvz', defaultMessage: 'Shared by {name}', description: 'Share status showing the name of who shared the trip' }, { name: owner.givenName })
            : intl.formatMessage({ id: 'nb1IUkKnUIzv81nNMSiO', defaultMessage: 'Shared by user', description: 'Share status when trip owner name is unavailable in the trip planner' })}
        </CaptionTextBlock>
      )}
    </>
  )
}
